/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatient
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatient {
    /**
     * 
     */
    patient_id?: string;
    /**
     * 
     */
    type?: HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientTypeEnum;
    /**
     * 
     */
    details_push_date?: string;
    /**
     * 
     */
    details_extraction_date?: string;
    /**
     * 
     */
    is_extracting_details?: boolean;
    /**
     * 
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_generated_document_upload_in_progress?: boolean;
}


/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB',
    MatrixCareHomeHealth: 'MATRIX_CARE_HOME_HEALTH',
} as const;
export type HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientTypeEnum = typeof HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientTypeEnum[keyof typeof HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientTypeEnum];


/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatient interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatient(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatient {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatient {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'] == null ? undefined : json['patient_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'details_push_date': json['details_push_date'] == null ? undefined : json['details_push_date'],
        'details_extraction_date': json['details_extraction_date'] == null ? undefined : json['details_extraction_date'],
        'is_extracting_details': json['is_extracting_details'] == null ? undefined : json['is_extracting_details'],
        'is_screener_document_upload_in_progress': json['is_screener_document_upload_in_progress'] == null ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': json['is_additional_document_upload_in_progress'] == null ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': json['is_generated_document_upload_in_progress'] == null ? undefined : json['is_generated_document_upload_in_progress'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatient {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatientToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerExternalEhrPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
        'type': value['type'],
        'details_push_date': value['details_push_date'],
        'details_extraction_date': value['details_extraction_date'],
        'is_extracting_details': value['is_extracting_details'],
        'is_screener_document_upload_in_progress': value['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': value['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': value['is_generated_document_upload_in_progress'],
    };
}

